import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=54cf75aa&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"
import style0 from "./notices.vue?vue&type=style&index=0&id=54cf75aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf75aa",
  null
  
)

export default component.exports